import { connect } from 'react-redux';

import { getAccount } from '../actions';
import { openVippsModal, updateVippsConnection } from '../../vipps/actions';
import { openVippsCallbackModal } from '../../vippsCallback/actions';
import { openInstabankModal } from '../../instabank/actions';
import { openPayExModal } from '../../payex/actions';
import { openSwishModal } from '../../swish/actions';
import { openSwishCallbackModal } from '../../swishCallback/actions';
import { openBamboraCallbackModal } from '../../bamboraCallback/actions';
import { openPayExCallbackModal } from '../../payexCallback/actions';
import { State } from '../../../../reducer';

import ConnectionsPage from '../components/ConnectionsPage';

const mapStateToProps = (state: State) => ({
});

const mapDispatchToProps = {
    getAccount,
    openVippsModal,
    openVippsCallbackModal,
    openInstabankModal,
    openPayExModal,
    openPayExCallbackModal,
    openSwishModal,
    openSwishCallbackModal,
    openBamboraCallbackModal,
    updateVippsConnection,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectionsPage);
